import {
  Conversation,
  ConversationLogItemMessageAdded,
} from '@stripe-internal/conversations-client';
import {AttachmentMessageRow} from './AttachmentMessageRow';
import {TextMessageRow} from './TextMessageRow';
import {RichTextMessageRow} from './RichTextMessageRow';
import {SelectOptionsMessageRow} from './SelectOptionsMessageRow';
import {ButtonOptionsMessageRow} from './ButtonOptionsMessageRow';
import {ArticlesMessageRow} from './ArticlesMessageRow';
import {avatarForMessage} from './avatarForMessage';
import {InlineDataMessageRow} from './InlineDataMessageRow';
import {ButtonsMessageRow} from './ButtonsMessageRow';

export function rowForMessage({
  conversation,
  item,
  avatar,
  animated,
  disableInteraction,
  disableAvatar,
}: {
  conversation: Conversation;
  item: ConversationLogItemMessageAdded;
  avatar?: React.ReactNode | null | undefined;
  animated?: boolean;
  disableInteraction?: boolean;
  disableAvatar?: boolean;
}) {
  const itemAvatar = disableAvatar
    ? undefined
    : avatar || avatarForMessage(item);

  const {message} = item;
  switch (message.type) {
    case 'attachment-conversation-message':
      return (
        <AttachmentMessageRow
          key={`attachment-message-row-${item.id}`}
          conversation={conversation}
          message={message}
          avatar={itemAvatar}
        />
      );
    case 'select-options-conversation-message':
      return (
        <SelectOptionsMessageRow
          key={`select-options-message-row-${item.id}`}
          conversation={conversation}
          message={message}
          disableInteraction={disableInteraction}
        />
      );
    case 'button-options-conversation-message':
      return (
        <ButtonOptionsMessageRow
          key={`button-options-message-row-${item.id}`}
          conversation={conversation}
          message={message}
          animated={animated}
          disableInteraction={disableInteraction}
        />
      );
    case 'articles-conversation-message':
      return (
        <ArticlesMessageRow
          key={`articles-message-row-${item.id}`}
          conversation={conversation}
          message={message}
          avatar={itemAvatar}
        />
      );
    case 'buttons-conversation-message':
      return (
        <ButtonsMessageRow
          key={`buttons-message-row-${item.id}`}
          conversation={conversation}
          message={message}
        />
      );
    case 'text-conversation-message':
      return (
        <TextMessageRow
          key={`text-message-row-${item.id}`}
          conversation={conversation}
          message={message}
          avatar={itemAvatar}
        />
      );
    case 'inline-data-conversation-message':
      return (
        <InlineDataMessageRow
          key={`inline-data-message-row-${item.id}`}
          conversation={conversation}
          message={message}
          avatar={itemAvatar}
        />
      );
    case 'rich-text-conversation-message':
      return (
        <RichTextMessageRow
          key={`rich-text-message-row-${item.id}`}
          conversation={conversation}
          message={message}
          avatar={itemAvatar}
          disableInteraction={disableInteraction}
        />
      );
    default:
      return null;
  }
}
